import React, { Component, Fragment } from "react";
import { gql } from "@apollo/client";
import { apolloClient } from "../../index";
import "./CreateNewFolder.scss";
import CloseIcon from "../../assets/icons/close.svg";
import ColorCodeDropdown from "../ColorCodeDropdown/ColorCodeDropdown";
import Dropdown from "react-bootstrap/Dropdown";
import ArrowDown from "../../assets/icons/arrows/chevron-down.svg";
import dateFormat from "dateformat";
import { notify } from "../Notify/Notify";
import ShareWith from "./ShareWith/ShareWith";
import { Modal } from "react-bootstrap";
import { ManageApprovalModal } from "./ApprovalFlow/index";
import { v4 } from "uuid";
import classNames from "classnames";
import { deepCopy, optionalChaining } from "../../helper";
import deepEqual from "fast-deep-equal";
import { sort } from "fast-sort";
import {
  COLOR_CODE_FOR_WORKSPACE,
  CREATE_NEW_WORKSPACE,
  WORKSPACE_DESCRIPTION,
  WORKSPACE_INSTRUCTIONS,
  WORKSPACE_LOCATION,
  WORKSPACE_NAME,
} from "../../constants/workspaces";

// Define action constants
export const ADD_LEVEL = "ADD_LEVEL";
export const REMOVE_LEVEL = "REMOVE_LEVEL";
export const UPDATE_LEVEL = "UPDATE_LEVEL";
export const REORDER_LEVELS = "REORDER_LEVELS";
export const UPDATE_ALL_LEVELS = "UPDATE_ALL_LEVELS";

const folderColors = [
  { id: 1, value: "1", label: "Red", colorCode: "#ff9ead" },
  { id: 2, value: "2", label: "Orange", colorCode: "#ffa575" },
  { id: 3, value: "3", label: "Yellow", colorCode: "#ffda6b" },
  { id: 4, value: "4", label: "Green", colorCode: "#86e575" },
  { id: 5, value: "5", label: "Teal", colorCode: "#6de4d2" },
  { id: 6, value: "6", label: "Purple", colorCode: "#c09eff" },
  { id: 7, value: "7", label: "Primary", colorCode: "#cbd1fe" },
];

const defaultApprovalLevels = {
  id: v4(),
  levelName: "",
  order: 1,
  users: [],
};

class CreateNewFolder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      folderTitle: "",
      parentFolder: !this.props.doNotShowRootOption
        ? 0
        : this.props.allRootFolders[0].id,
      folderColor: folderColors[6],
      shareUser: "",
      folderDescription: "",
      folderInstruction: "",
      childFoldersList: [],
      isFoldersListLoaded: true,
      showDropDown: false,
      accessUsers: [],
      filteredUsers: [],
      folderAccess: [
        { id: 31, access: "Owner" },
        { id: 32, access: "Collaborator" },
        { id: 33, access: "Viewer" },
        { id: 34, access: "Temporary User" },
      ],
      isApprovalRequired: false,
      isApprovalLevelsPopupOpened: false,
      approvalLevels: [{ ...defaultApprovalLevels }],
      currentFolderIdForApproval: "",
      isMutationApiLoading: false,
      initialValueForIsApprovalRequiredForEdit: false,
      initialValueForApprovalLevels: [],
      isEditApproval: false,
      approvalLevelDataForEditFolder: [],
      currentEditedRow: {},
      isApprovalMutationLoading: false,
    };
  }

  // Handle approval mutations
  handleApprovalLevelsMutation = (action, payload) => {
    const { approvalLevels } = this.state;

    switch (action) {
      case ADD_LEVEL:
        this.setState({
          approvalLevels: [
            ...approvalLevels,
            {
              id: v4(),
              levelName: "",
              order: approvalLevels.length + 1,
              users: [],
            },
          ],
        });
        break;

      case REMOVE_LEVEL:
        this.setState({
          approvalLevels: approvalLevels.filter(
            (level) => level.id !== payload
          ),
        });
        break;

      case UPDATE_LEVEL:
        this.setState({
          approvalLevels: approvalLevels.map((level) =>
            level.id === payload.id ? { ...level, ...payload.data } : level
          ),
        });
        break;

      case UPDATE_ALL_LEVELS:
        this.setState({
          approvalLevels: payload, // Assuming payload is the updated array
        });
        break;

      default:
        // Handle other cases or throw an error for unsupported actions
        break;
    }
  };
  resetApprovalLevels = () => {
    this.setState({
      approvalLevels: [{ ...defaultApprovalLevels }],
      accessUsers: [this.state.accessUsers[0]],
    });
  };
  approvalLevelsPopupCloseHandler = async (
    isCalledForMutation = false,
    isUpdateAll = true
  ) => {
    if (isCalledForMutation) {
      this.setState({
        isApprovalMutationLoading: true,
      });

      const {
        currentFolderIdForApproval,
        approvalLevels,
        initialValueForApprovalLevels,
      } = this.state;
      if (approvalLevels.some((level) => level?.users?.length === 0)) {
        notify(
          "Error",
          "Unable to proceed. Please ensure at least one approval is added to each levels.",
          "error"
        );
        this.setState({
          isApprovalMutationLoading: false,
        });
        return;
      }
      const { loadData: fetchAllDocs = () => {}, fetchSubFolders = () => {} } =
        this.props;
      if (this.state.isEditApproval) {
        const payload = compareApprovalLevels(
          initialValueForApprovalLevels,
          approvalLevels
        );
        const UPDATE_FOLDER_LEVELS = gql`
          mutation (
            $createdLevels: [CreateFolderApprovalLevelInputType]!
            $deletedLevels: [DeleteFolderApprovalLevelInputType]!
            $folderId: UUID!
            $updateApproved: Boolean!
            $updatedLevels: [EditFolderApprovalLevelInputType]!
          ) {
            updateFolderLevels(
              createdLevels: $createdLevels
              deletedLevels: $deletedLevels
              folderId: $folderId
              updateApproved: $updateApproved
              updatedLevels: $updatedLevels
            ) {
              success
              folderApprovalLevels {
                id
                name
                users {
                  id
                  isActive
                  username
                  firstName
                  lastName
                  email
                  profile {
                    imageUrl: image
                  }
                }
                sequence
              }
            }
          }
        `;
        const variables = {
          folderId: this.state.currentFolderIdForApproval,
          updateApproved: isUpdateAll,
          ...payload,
        };
        try {
          const result = await apolloClient.mutate({
            variables,
            mutation: UPDATE_FOLDER_LEVELS,
          });
          const { currentEditedRow } = this.state;
          const localCurrentEditedRow = deepCopy(currentEditedRow);
          localCurrentEditedRow["editFolder"]["approvalLevels"] =
            result.data.updateFolderLevels.folderApprovalLevels;
          this.props.onFolderUpdated(localCurrentEditedRow);
          this.resetApprovalLevels();
          this.resetFormHandler();
          this.setState({
            isApprovalLevelsPopupOpened: false,
          });
          fetchAllDocs();
          fetchSubFolders(false);
          const title = "Success";
          const detail = "Approval level updated successfully!";
          const type = "success";
          notify(title, detail, type);
        } catch (error) {
          const title = "Error";
          const detail = error.message;
          const type = "error";
          notify(title, detail, type);
          console.error(error);
        }
      } else {
        const levels = approvalLevels.map((approvalLevel, index) => ({
          name: approvalLevel.levelName,
          users: approvalLevel.users.map((user) => user.id),
          sequence: Number(approvalLevel.order),
        }));
        if (levels.some((level) => level?.users?.length === 0)) {
          notify(
            "Error",
            "Unable to proceed. Please ensure at least one approval is added to each levels.",
            "error"
          );
          this.setState({
            isApprovalMutationLoading: false,
          });
          return;
        }
        const mutation = gql`
          mutation (
            $folderId: String!
            $levels: [CreateFolderApprovalLevelInputType!]!
          ) {
            createApprovalLevelsForFolder(
              folderId: $folderId
              levels: $levels
            ) {
              success
            }
          }
        `;
        const variables = {
          folderId: currentFolderIdForApproval,
          levels,
        };
        try {
          await apolloClient.mutate({
            variables,
            mutation,
          });
          this.setState({
            isApprovalLevelsPopupOpened: false,
          });
          const {
            onApprovalAddedForAFolder = () =>
              console.log("onApprovalAddedForAFolder is not coming in props"),
          } = this.props;
          onApprovalAddedForAFolder(
            currentFolderIdForApproval,
            formatApprovalLevels(approvalLevels)
          );
          this.resetApprovalLevels();
          this.resetFormHandler();
        } catch (error) {
          const title = "Error";
          const detail = error.message;
          const type = "error";
          notify(title, detail, type);
          console.error(error);
        }
      }
      this.setState({
        isApprovalMutationLoading: false,
      });
    } else {
      this.resetApprovalLevels();
      this.resetFormHandler();
      this.setState({
        isApprovalLevelsPopupOpened: false,
      });
    }
  };
  resetFormHandler = () => {
    this.setState({
      isApprovalRequired: false,
      accessUsers: [this.state.accessUsers[0]],
      initialValueForIsApprovalRequiredForEdit: false,
      approvalLevelDataForEditFolder: [],
      initialValueForApprovalLevels: [],
      isEditApproval: false,
    });
    this.resetApprovalLevels();
  };
  locationDropdown = React.forwardRef(({ onClick }, ref) => (
    <button
      className="btn-dropdown btn-location-dropdown mr-2"
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      <div className="text-label">
        {" "}
        {this.state.parentFolder === 0
          ? "(Root Level)"
          : [...this.props.allRootFolders].filter(
              (obj) => obj.id === this.state.parentFolder
            )[0]
          ? [...this.props.allRootFolders].filter(
              (obj) => obj.id === this.state.parentFolder
            )[0].title
          : ""}
      </div>
      <img
        className="ml-1 mr-0"
        width="20"
        height="20"
        src={ArrowDown}
        alt="arrowDown"
      />
    </button>
  ));

  getTotalDays = (date) => {
    const dateDay = dateFormat(date, "dd");
    const dateMonth = dateFormat(date, "mm");
    const dateYear = dateFormat(date, "yyyy");

    let first = new Date();
    let second = new Date(
      parseInt(dateYear),
      parseInt(dateMonth) - 1,
      parseInt(dateDay)
    );

    const totalDays = Math.round((second - first) / (1000 * 60 * 60 * 24));
    return totalDays;
  };

  setAccessUsers = (usersArr) => {
    const filteredArr = usersArr.reduce((acc, current) => {
      const x = acc.find((item) => item.id === current.id);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    this.setState({ accessUsers: filteredArr });
  };

  setFilteredUsers = (filterUsers) => {
    this.setState({ filteredUsers: filterUsers });
  };
  /**
   * Handles folder submission, considering approval requirements,
   * folder creation, and editing. Invokes appropriate actions and
   * manages the folder modal state.
   *
   * @param {Event} e - The event object.
   */
  submitFolderHelper = async (e) => {
    e.preventDefault();
    const {
      createSubFolder = false,
      editFolder = false,
      isEditingASubFolder = false,
      handleFolderModal = () =>
        console.log("handleFolderModal is not provided"),
    } = this.props;

    const { isApprovalRequired } = this.state;

    if (editFolder) {
      const isSuccess = await this.updatedFolder();
      if (
        !this.state.initialValueForIsApprovalRequiredForEdit &&
        isApprovalRequired &&
        isEditingASubFolder &&
        isSuccess
      ) {
        handleFolderModal(false);
        this.setState({
          isApprovalLevelsPopupOpened: true,
          approvalLevels: [{ ...defaultApprovalLevels }],
          isEditApproval: false,
        });
        return;
      }
      if (isSuccess) {
        handleFolderModal(false);
      }
    } else {
      const isSuccess = await this.submitCreateFolder();
      if (isSuccess) {
        handleFolderModal(false);
        if (isApprovalRequired && (createSubFolder || isEditingASubFolder)) {
          this.setState({
            isApprovalLevelsPopupOpened: true,
            isEditApproval: false,
          });
        } else {
          this.setState({
            accessUsers: [this.state.accessUsers[0]],
          });
        }
      } else {
        // Handler failure
      }
    }
  };
  handleEditApprovalLevel = async () => {
    const isSuccess = await this.updatedFolder(true);
    if (isSuccess) {
      this.props.handleFolderModal(false);
      this.setState({
        isApprovalLevelsPopupOpened: true,
        isEditApproval: true,
      });
    }
  };
  submitCreateFolder = async () => {
    this.setState({
      isMutationApiLoading: true,
    });
    let userIds_data = [];
    this.state.accessUsers.map((accessUser, index) => {
      return index !== 0 && accessUser.access !== "Temporary User"
        ? userIds_data.push({
            id: accessUser.id,
            role: accessUser.access,
          })
        : accessUser.access === "Temporary User"
        ? userIds_data.push({
            id: accessUser.id,
            role: "Temporary User",
            days: this.getTotalDays(accessUser.temporaryDate),
          })
        : null;
    });

    const variables = {
      title: this.state.folderTitle.trim(),
      description: this.state.folderDescription.trim(),
      instruction: this.state.folderInstruction.trim(),
      isRoot: this.state.parentFolder === 0,
      color: this.state.folderColor.colorCode,
      userIds: JSON.stringify(userIds_data),
      approvalRequired: this.state.isApprovalRequired,
    };
    let mutation;
    if (!variables.isRoot) {
      variables["parentFolderId"] = this.state.parentFolder;
      mutation = `
      mutation CreateFolder(
        $title: String!
        $description: String!
        $instruction: String!
        $isRoot: Boolean!
        $color: String!
        $parentFolderId: UUID!
        $userIds: String!
        $approvalRequired: Boolean!
      ) {
        createFolder(
          title: $title
          description: $description
          instruction: $instruction
          isRoot: $isRoot
          color: $color
          userIds: $userIds
          parentFolderId: $parentFolderId
          approvalRequired: $approvalRequired
        ) {
          folder {
            id
            title
            isRoot
            color {
              id
              name
            }
            approvalRequired
            description
            instruction
            createdBy {
              profile{
                image
                role {
                  id
                  name
                }
              }
              id
              username
              firstName
              lastName
              email
            }
            modifiedTs
            parentFolder {
              id
              title
            }
            sharedFolder {
              id
              user {
                id
                email
                username
                firstName
                lastName
                profile {
                  image
                  role {
                    id
                    name
                  }
                }
              }
              userRole {
                id
                name
              }
            }
            pinnedFolder {
              user {
                id
              }
              folder {
                id
                title
              }
            }
          }
        }
      }`;
    } else {
      mutation = `mutation CreateFolder(
        $title: String!
        $description: String!
        $instruction: String!
        $isRoot: Boolean!
        $color: String!
        $userIds: String!
      ) {
        createFolder(
          title: $title
          description: $description
          instruction: $instruction
          isRoot: $isRoot
          color: $color
          userIds: $userIds
        ) {
          folder {
            id
            title
            isRoot
            color {
              id
              name
            }
            description
            instruction
            createdBy {
              id
              firstName
              lastName
              email
              username
              profile {
                image
                role {
                  id
                  name
                }
              }
            }
            sharedFolder {
              id
              user {
                id
                email
                username
                firstName
                lastName
                profile {
                  image
                  role {
                    id
                    name
                  }
                }
              }
              userRole {
                id
                name
              }
            }
            pinnedFolder {
              user {
                id
              }
              folder {
                id
                title
              }
            }
            modifiedTs
          }
        }
      }`;
    }
    let isSuccess = false;
    await apolloClient
      .mutate({
        variables: variables,
        mutation: gql`
          ${mutation}
        `,
      })
      .then((result) => {
        const currentFolderIdForApproval = optionalChaining(result, [
          "data",
          "createFolder",
          "folder",
          "id",
        ]);
        this.props.onNewFolderAdded({
          ...result.data,
          parentFolderId: !variables.isRoot ? this.state.parentFolder : null,
        });
        const childFoldersList = [...this.state.childFoldersList];
        childFoldersList.push(
          this.state.folderTitle.trim().toLocaleLowerCase()
        );
        this.setState({
          folderTitle: "",
          folderColor: folderColors[6],
          parentFolder: !this.props.doNotShowRootOption
            ? 0
            : this.props.allRootFolders[0].id,
          shareUser: "",
          folderDescription: "",
          folderInstruction: "",
          childFoldersList: childFoldersList,
          showDropDown: false,
          showDatePiker: false,
          filteredUsers: [],
          currentFolderIdForApproval,
        });
        isSuccess = true;
      })
      .catch((e) => {
        const title = "Error";
        const detail = e.message.includes("Guest user")
          ? "Please provide only Temporary User access to a Guest user!"
          : e.message;
        const type = "error";
        notify(title, detail, type);
        isSuccess = false;
      });
    this.setState({
      isMutationApiLoading: false,
    });
    return isSuccess;
  };

  updatedFolder = async (shouldSaveOnFolderUpdatedData = false) => {
    this.setState({
      isMutationApiLoading: true,
    });
    const variables = {
      folderId: this.props.updateFolder.id,
      title: this.state.folderTitle,
      description: this.state.folderDescription || "",
      instruction: this.state.folderInstruction || "",
      color: this.state.folderColor.colorCode,
      approvalRequired: this.state.initialValueForIsApprovalRequiredForEdit
        ? true
        : this.state.isApprovalRequired,
    };
    let isSuccess = false;
    await apolloClient
      .mutate({
        variables: variables,
        mutation: gql`
          mutation EditFolder(
            $folderId: UUID!
            $title: String
            $description: String
            $instruction: String
            $color: String
            $approvalRequired: Boolean!
          ) {
            editFolder(
              folderId: $folderId
              title: $title
              description: $description
              instruction: $instruction
              color: $color
              approvalRequired: $approvalRequired
            ) {
              success
            }
          }
        `,
      })
      .then((result) => {
        this.setState({
          currentFolderIdForApproval: this.props.updateFolder.id,
        });
        const {
          createdBy,
          sharedFolder,
          parentFolder,
          pinnedFolder,
          modifiedTs,
        } = this.props.updateFolder;
        const editFolder = {
          id: this.props.updateFolder.id,
          title: this.state.folderTitle,
          color: this.state.folderColor,
          description: this.state.folderDescription,
          instruction: this.state.folderInstruction,
          createdBy,
          sharedFolder,
          isArchive: false,
          isRoot: parentFolder ? false : true,
          parentFolder,
          pinnedFolder,
          modifiedTs,
          approvalRequired: variables.approvalRequired,
          approvalLevels: this.state.approvalLevelDataForEditFolder,
        };
        if (shouldSaveOnFolderUpdatedData) {
          this.setState({
            currentEditedRow: {
              editFolder: editFolder,
              parentFolderId: this.props.updateFolder.parentFolder
                ? this.props.updateFolder.parentFolder.id
                : null,
            },
          });
        }
        this.props.onFolderUpdated({
          editFolder: editFolder,
          parentFolderId: this.props.updateFolder.parentFolder
            ? this.props.updateFolder.parentFolder.id
            : null,
        });

        const title = "Success";
        const detail = "Folder updated successfully!";
        const type = "success";
        notify(title, detail, type);
        isSuccess = true;
      })
      .catch((e) => {
        const title = "Error";
        const detail = e.message;
        const type = "error";
        notify(title, detail, type);
        isSuccess = false;
      });
    this.setState({
      isMutationApiLoading: false,
    });
    return isSuccess;
  };

  hasValidValue = () => {
    if (this.state.isMutationApiLoading) {
      return false;
    }
    if (this.props.editFolder) {
      const childs = [...this.state.childFoldersList];
      const updatedChilds = childs.filter(
        (child) => child !== this.props.updateFolder.title
      );
      const Title = this.state.folderTitle.toLowerCase();
      const isValid =
        this.state.isFoldersListLoaded ||
        !updatedChilds.includes(this.state.folderTitle.trim().toLowerCase()) ||
        this.state.folderColor;
      return (
        isValid &&
        !Title.includes("personal folder") &&
        this.state.folderTitle.trim().length > 0
      );
    } else {
      const Title = this.state.folderTitle.toLowerCase();
      return (
        this.state.folderTitle.trim().length > 0 &&
        !Title.includes("personal folder") &&
        this.state.isFoldersListLoaded &&
        !this.state.childFoldersList.includes(
          this.state.folderTitle.trim().toLowerCase()
        ) &&
        this.state.folderColor
      );
    }
  };

  getAllChildFolders = () => {
    const folder = this.props.folder ? this.props.folder[0] : undefined;
    const variables = folder
      ? {
          parentFolderId: folder.parentFolder
            ? folder.parentFolder.id
            : folder.id,
        }
      : {
          parentFolderId: this.state.parentFolder,
        };

    if (this.state.isFoldersListLoaded)
      this.setState({ isFoldersListLoaded: false });

    apolloClient
      .query({
        query: gql`
          query subFolder($parentFolderId: UUID!) {
            subFolders(parentFolderId: $parentFolderId) {
              folderId: id
              title
              approvalRequired
              approvalLevels {
                id
                name
                users {
                  id
                  firstName
                  lastName
                  email
                  profile {
                    imageUrl: image
                  }
                }
                sequence
              }
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        let childFoldersList = [];
        result.data.subFolders.map((item) =>
          childFoldersList.push(item.title.toLowerCase())
        );
        this.setState({ childFoldersList, isFoldersListLoaded: true });
      })
      .catch((e) => {
        this.setState({ isLoading: false });
        const title = "Error";
        const detail = e.message;
        const type = "error";
        notify(title, detail, type);
      });
  };

  loadRootChildren = () => {
    if (this.state.isFoldersListLoaded)
      this.setState({ isFoldersListLoaded: false });

    apolloClient
      .query({
        query: gql`
          query {
            foldersForUser {
              id
              title
            }
          }
        `,
      })
      .then((result) => {
        let childFoldersList = [];
        result.data.foldersForUser.map((item) =>
          childFoldersList.push(item.title.toLowerCase())
        );
        this.setState({ childFoldersList, isFoldersListLoaded: true });
      })
      .catch((e) => {
        this.setState({ isLoading: false });
        const title = "Error";
        const detail = e.message;
        const type = "error";
        notify(title, detail, type);
      });
  };

  cancelHandler = () => {
    this.props.handleFolderModal();
    if (this.props.editFolder) {
      const folder = this.props.updateFolder;
      this.setState({
        folderTitle: folder.title,
        folderColor: folderColors[parseInt(folder.color.id) - 1],
        folderDescription: folder.description,
        folderInstruction: folder.instruction,
        accessUsers: [],
      });
    } else {
      this.setState({
        folderTitle: "",
        folderColor: folderColors[6],
        folderDescription: "",
        folderInstruction: "",
        accessUsers: [],
        isApprovalRequired: false,
      });
    }
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutsideOfUserSearch);
  }

  componentDidUpdate(prevProps) {
    if (this.props.updateFolder) {
      const length = Object.entries(this.props.updateFolder).length;
      const check = this.props.updateFolder.id !== prevProps.updateFolder.id;
      if (length > 0 && check) {
        const folder = this.props.updateFolder;
        if (folder.parentFolder) {
          this.getAllChildFolders();
        } else {
          this.loadRootChildren();
        }
        this.setState({
          folderTitle: folder.title,
          folderColor: folderColors[parseInt(folder.color.id) - 1],
          folderDescription: folder.description,
          folderInstruction: folder.instruction,
          approvalLevels: transformApprovalAPiDataToStateForm(
            folder.approvalLevels
          ),
          approvalLevelDataForEditFolder: folder.approvalLevels,
          initialValueForIsApprovalRequiredForEdit: Boolean(
            folder.approvalRequired
          ),
          initialValueForApprovalLevels: transformApprovalAPiDataToStateForm(
            folder.approvalLevels
          ),
          accessUsers: [
            ...this.state.accessUsers,
            ...getUsersFromSharedWith(folder.sharedFolder),
          ],
        });
      } else if (length === 0 && check) {
        this.getAllChildFolders();
        this.setState({
          folderTitle: "",
          folderColor: folderColors[6],
          folderDescription: "",
          folderInstruction: "",
        });
      }
    }
    // Handle subfolder selection
    if (
      this.props.allRootFolders?.length === 1 &&
      this.props.allRootFolders[0].id !== this.state.parentFolder &&
      this.props.doNotShowRootOption
    ) {
      this.setState({
        parentFolder: this.props.allRootFolders[0].id,
      });
    }
  }
  shouldGiveOptionToEditApprovalLevels = () => {
    const { updateFolder, currentUserInfo } = this.props;
    if (!updateFolder) {
      return;
    }
    const ownerId = optionalChaining(updateFolder, ["createdBy", "id"], "");
    const currentUserId = optionalChaining(currentUserInfo, ["id"], "no user");

    const isOwner = updateFolder?.sharedFolder?.some(
      (item) => item.user.id === currentUserId && item.userRole.name === "Owner"
    );
    return ownerId === currentUserId || isOwner;
  };
  render() {
    let isDuplicateFolderName = false;
    let isPersonalFolder = false;
    let isDisabled = false;
    const isApprovalRequired = optionalChaining(
      this.props,
      ["updateFolder", "approvalRequired"],
      false
    );
    const childs = [...this.state.childFoldersList];
    if (this.props.editFolder) {
      const updatedChilds = childs.filter(
        (child) =>
          child.toLowerCase() !== this.props.updateFolder.title.toLowerCase()
      );
      if (
        this.state.isFoldersListLoaded &&
        updatedChilds.includes(this.state.folderTitle.trim().toLowerCase())
      ) {
        isDuplicateFolderName = true;
      }

      // personal folder validation
      if (
        !this.props.updateFolder.title.toLowerCase().includes("personal folder")
      ) {
        const Title = this.state.folderTitle.toLowerCase();
        if (Title.length > 0 && Title.includes("personal folder")) {
          isPersonalFolder = true;
        }
        isDisabled = false;
      } else {
        isDisabled = true;
      }
    } else {
      if (
        this.state.isFoldersListLoaded &&
        this.state.childFoldersList.includes(
          this.state.folderTitle.trim().toLowerCase()
        )
      ) {
        isDuplicateFolderName = true;
      }

      // personal folder validation
      const Title = this.state.folderTitle.toLowerCase();
      if (Title.length > 0 && Title.includes("personal folder")) {
        isPersonalFolder = true;
      }
    }

    return (
      <Fragment>
        <Modal
          size="lg"
          dialogClassName={`${
            !this.props.editFolder ? "default-dialog" : "default-dialog-edit"
          }`}
          show={this.props.showFolderModal}
          onHide={() => this.props.handleFolderModal(false)}
          centered
        >
          <Modal.Header>
            {!this.props.editFolder ? (
              <h4 className="modal-title">
                {this.props.createSubFolder
                  ? "Create New Sub Folder"
                  : CREATE_NEW_WORKSPACE}
              </h4>
            ) : (
              <h4 className="modal-title">Edit Folder</h4>
            )}
            <img
              className="close"
              src={CloseIcon}
              alt="closeIcon"
              onClick={() => {
                this.props.handleFolderModal();
                this.resetFormHandler();
              }}
            />
          </Modal.Header>
          <Modal.Body>
            <div className="container-fluid">
              <div className="row d-flex justify-content-center">
                <div
                  className={`${
                    !this.props.editFolder ? "col-md-5" : "col-md-12"
                  }`}
                >
                  <div>
                    <label>
                      {this.props.createSubFolder
                        ? "Folder Name"
                        : WORKSPACE_NAME}
                      *
                    </label>
                    <input
                      type="text"
                      placeholder="Enter folder name"
                      maxLength="50"
                      onChange={(e) => {
                        this.setState({ folderTitle: e.target.value });
                      }}
                      value={this.state.folderTitle}
                      disabled={isDisabled}
                      className={this.props.editFolder ? "handle-width" : ""}
                    />
                    {isDuplicateFolderName ? (
                      <span className="error-message">
                        Folder name is already existing. Please rename the
                        folder name.
                      </span>
                    ) : isPersonalFolder ? (
                      <span className="error-message">
                        Please avoid using keyword personal folder in the folder
                        name
                      </span>
                    ) : null}
                  </div>
                  {!this.props.editFolder ? (
                    <div className="mt-8">
                      <label>
                        {this.props.createSubFolder
                          ? "Folder Location"
                          : WORKSPACE_LOCATION}
                        *
                      </label>
                      <Dropdown
                        alignRight
                        className="ml-auto location-dropdown"
                      >
                        <Dropdown.Toggle
                          as={this.locationDropdown}
                        ></Dropdown.Toggle>
                        <Dropdown.Menu>
                          {!this.props.doNotShowRootOption ? (
                            <Dropdown.Item
                              as="a"
                              key="0"
                              value={0}
                              className={
                                this.state.parentFolder === 0
                                  ? "selected text-label"
                                  : "text-label"
                              }
                              onClick={(e) => {
                                this.setState(
                                  {
                                    parentFolder: 0,
                                  },
                                  this.loadRootChildren
                                );
                              }}
                            >
                              (Root Level)
                            </Dropdown.Item>
                          ) : null}

                          {this.props.allRootFolders.map((flKey) => (
                            <Dropdown.Item
                              as="a"
                              key={flKey.id}
                              value={flKey.id}
                              className={
                                this.state.parentFolder === flKey.id
                                  ? "selected text-label"
                                  : "text-label"
                              }
                              onClick={(e) => {
                                this.setState(
                                  {
                                    parentFolder: flKey.id,
                                  },
                                  this.getAllChildFolders
                                );
                              }}
                            >
                              {flKey.title}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  ) : null}
                  <div className="mt-8">
                    <label>
                      {this.props.createSubFolder
                        ? "Color Code For Folder"
                        : COLOR_CODE_FOR_WORKSPACE}
                      *
                    </label>
                    <ColorCodeDropdown
                      editFolder={this.props.editFolder}
                      colorCodes={folderColors}
                      folderColor={this.state.folderColor}
                      handleColorCodeClick={(colorObj) => {
                        this.setState({ folderColor: colorObj });
                      }}
                    />
                  </div>
                  <div className="mt-8">
                    <label>
                      {this.props.createSubFolder
                        ? "Folder Description"
                        : WORKSPACE_DESCRIPTION}
                    </label>
                    <textarea
                      placeholder="Pro Tip: inserting a folder description is a great way to promote process standardization."
                      maxLength="300"
                      onChange={(e) => {
                        this.setState({ folderDescription: e.target.value });
                      }}
                      value={this.state.folderDescription}
                      className={this.props.editFolder ? "handle-width" : ""}

                      // required
                    />
                  </div>
                  {!this.state.folderTitle
                    .toLowerCase()
                    .includes("personal folder") ? (
                    <div className="mt-8">
                      <label>
                        {this.props.createSubFolder
                          ? "Folder Instructions"
                          : WORKSPACE_INSTRUCTIONS}
                      </label>
                      <textarea
                        placeholder="Pro Tip: Inserting a folder instructions is a great way to promote proper naming conventions"
                        maxLength="300"
                        onChange={(e) => {
                          this.setState({ folderInstruction: e.target.value });
                        }}
                        value={this.state.folderInstruction}
                        className={this.props.editFolder ? "handle-width" : ""}
                      />
                    </div>
                  ) : null}
                </div>
                {!this.props.editFolder ? (
                  <ShareWith
                    colClass="col-md-7"
                    defaultRole="Owner"
                    folderAccess={this.state.folderAccess}
                    accessUsers={this.state.accessUsers}
                    filteredUsers={this.state.filteredUsers}
                    setAccessUsers={this.setAccessUsers}
                    setFilteredUsers={this.setFilteredUsers}
                    currentUserInfo={this.props.currentUserInfo}
                  />
                ) : null}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer
            className={classNames({
              "d-flex justify-content-between align-items-center":
                this.props.createSubFolder,
            })}
          >
            {this.props.createSubFolder &&
              (this.props.editFolder ? (
                <section className="d-flex align-items-center justify-content-start">
                  {false &&
                    this.props.isEditingASubFolder &&
                    this.shouldGiveOptionToEditApprovalLevels() &&
                    isApprovalRequired && (
                      <button
                        className="btn-primary"
                        onClick={this.handleEditApprovalLevel}
                        disabled={!this.hasValidValue()}
                      >
                        Edit Approval Levels
                      </button>
                    )}
                  {this.props.isEditingASubFolder &&
                    this.shouldGiveOptionToEditApprovalLevels() &&
                    !isApprovalRequired &&
                    false && (
                      <Fragment>
                        <input
                          type="checkbox"
                          id="approvalCheckbox"
                          onChange={() =>
                            this.setState({
                              isApprovalRequired:
                                !this.state.isApprovalRequired,
                            })
                          }
                          checked={this.state.isApprovalRequired}
                        />
                        <label htmlFor="approvalCheckbox" className="pl-2 mb-0">
                          Approval Required
                        </label>
                      </Fragment>
                    )}
                </section>
              ) : false ? (
                <section className="d-flex align-items-center justify-content-start">
                  <input
                    type="checkbox"
                    id="approvalCheckbox"
                    onChange={() =>
                      this.setState({
                        isApprovalRequired: !this.state.isApprovalRequired,
                      })
                    }
                    checked={this.state.isApprovalRequired}
                  />
                  <label htmlFor="approvalCheckbox" className="pl-2 mb-0">
                    Approval Required
                  </label>
                </section>
              ) : (
                <section>
                  <span>{""}</span>
                </section>
              ))}
            <section className="d-flex">
              <button
                type="button"
                className="btn-secondary mr-4"
                data-dismiss="modal"
                onClick={this.cancelHandler}
              >
                Cancel
              </button>

              <button
                type="submit"
                className="btn-primary"
                onClick={this.submitFolderHelper}
                disabled={!this.hasValidValue()}
              >
                {!this.props.editFolder ? <>Create</> : <>Update</>}
              </button>
            </section>
          </Modal.Footer>
        </Modal>
        <ManageApprovalModal
          isOpen={this.state.isApprovalLevelsPopupOpened}
          onCloseHandler={this.approvalLevelsPopupCloseHandler}
          mutationHandler={this.handleApprovalLevelsMutation}
          approvalLevels={this.state.approvalLevels}
          isEditApprovalMode={this.state.isEditApproval}
          accessUsers={this.state.accessUsers}
          isLoading={this.state.isApprovalMutationLoading}
        />
      </Fragment>
    );
  }
}

export default CreateNewFolder;

// Helper function
function formatApprovalLevels(approvalLevels) {
  return approvalLevels.map((level) => ({
    id: level.id,
    name: level.levelName,
    users: level.users.map((user) => ({
      id: user.id,
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      profile: {
        imageUrl: user.profile.image,
        __typename: "ProfileType",
      },
      __typename: "UserType",
    })),
    sequence: level.order,
    __typename: "FolderApprovalLevelType",
  }));
}

function transformApprovalAPiDataToStateForm(propsArray = []) {
  return sort(
    propsArray.map((props) => ({
      id: props.id,
      levelName: props.name || props.levelName,
      order: props.sequence || props.order,
      users: props.users.map((user) => ({
        __typename: user.__typename,
        id: user.id,
        username:
          user.username ||
          `${user.firstName.toLowerCase()}_${user.lastName.toLowerCase()}`,
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        profile: {
          __typename: user.profile.__typename,
          id: user.profile.id,
          image: user.profile.image,
          role: user.profile.role,
        },
        name: `${user.firstName} ${user.lastName}`,
        avatarUrl: user.avatarUrl,
        nameIntial: `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`,
      })),
    }))
  ).asc((u) => Number(u.order));
}

function compareApprovalLevels(initialLevels = [], finalLevels = []) {
  const createdLevels = [];
  const editedLevels = [];
  const deletedLevels = [];

  const userMap = new Map();
  initialLevels.forEach((level) => {
    level.users.forEach((user) => {
      userMap.set(user.id, user);
    });
  });

  initialLevels.forEach((initialLevel) => {
    const finalLevel = finalLevels.find(
      (level) => level.id === initialLevel.id
    );

    if (!finalLevel) {
      // Level is deleted
      deletedLevels.push({ id: initialLevel.id });
    } else {
      const editedLevel = {
        id: finalLevel.id,
      };

      if (finalLevel.levelName !== initialLevel.levelName) {
        editedLevel.updatedName = finalLevel.levelName;
      }

      if (finalLevel.order !== initialLevel.order) {
        editedLevel.updatedSequence = finalLevel.order;
      }

      editedLevel.removedUsers = initialLevel.users
        .filter(
          (initialUser) =>
            !finalLevel.users.find(
              (finalUser) => finalUser.id === initialUser.id
            )
        )
        .map((user) => user.id);

      editedLevel.addedUsers = finalLevel.users
        .filter(
          (finalUser) =>
            !initialLevel.users.find(
              (initialUser) => initialUser.id === finalUser.id
            )
        )
        .map((user) => user.id);

      // Include in editedLevels only if there are changes
      if (
        Object.keys(editedLevel).length > 1 || // Check if there are properties other than 'id'
        editedLevel.removedUsers.length > 0 ||
        editedLevel.addedUsers.length > 0
      ) {
        const updatedUserId = ["id", "removedUsers", "addedUsers"];
        if (deepEqual(Object.keys(editedLevel), updatedUserId)) {
          if (
            editedLevel.removedUsers.length > 0 ||
            editedLevel.addedUsers.length > 0
          ) {
            editedLevels.push(editedLevel);
          }
        } else {
          editedLevels.push(editedLevel);
        }
      }
    }
  });

  finalLevels.forEach((finalLevel) => {
    if (
      !initialLevels.find((initialLevel) => initialLevel.id === finalLevel.id)
    ) {
      createdLevels.push({
        name: finalLevel.levelName,
        users: finalLevel.users.map((user) => user.id),
        sequence: finalLevel.order,
      });
    }
  });

  return {
    createdLevels,
    deletedLevels,
    updatedLevels: editedLevels,
  };
}

function getUsersFromSharedWith(sharedWith) {
  try {
    if (!Array.isArray(sharedWith)) {
      throw new Error("Invalid input. Please provide a valid array.");
    }

    const users = sharedWith.map((item) => {
      if (item && item.user) {
        return item.user;
      } else {
        throw new Error("Invalid user data. Missing user object.");
      }
    });

    return users;
  } catch (error) {
    console.error("Error:", error.message);
    return [];
  }
}
